module.exports = __webpack_public_path__ + "static/media/bathroomFittings.48147d33.jpg";